
import { Component, Vue, Prop } from 'vue-property-decorator'
import { applicationRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { addApplication } from '@/api/enterpriseApp/enterpriseApp'
import { getType } from '@/utils/cookies'

@Component({
  name: 'addApplication',
  props: {
    availableCurrency: {
      type: Array,
      default: () => []
    },
    antCurrency: {
      type: Array,
      default: () => []
    }
  }
})
export default class extends Vue {
  private infoForm: any = {
    name: '',
    status: null,
    enterprise_type: '',
    available_currency: [],
    can_active: null
  }
  private rules = applicationRules
  private loading = false
  private type = getType()

  private back() {
    this.$emit('close', false)
  }

  private changeEnterpriseType () {
    console.log(this.$props.availableCurrency)

    this.infoForm.available_currency = []
  }

  private create() {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          await addApplication(this.infoForm).then(() => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.loading = false
            this.back()
          })
        } catch (e) {
          this.back()
          this.loading = false
        }
      } else {
        return false
      }
    })
  }
}
